import clsx from "clsx";
import ProductPlaceholderIcon from "@ancon/wildcat-ui/shared/static/placeholders/product-v2.svg";

import styles from "./ProductCardBanner.module.scss";

export type ProductCardBannerProps = {
  productName: string | null;
  disabled?: boolean;
  withoutImage?: boolean;
};

export default function ProductCardBanner({
  productName,
  disabled = false,
  withoutImage = false,
}: ProductCardBannerProps) {
  const bannerSrc = !withoutImage
    ? "https://source.unsplash.com/random/?burger&pizza&plate"
    : undefined;

  const defaultProductCardStyle = false;

  return (
    <div
      className={clsx(styles.container, {
        [styles.imageOnTopStyle]: !defaultProductCardStyle,
        [styles.disabled]: disabled,
      })}
    >
      {(!defaultProductCardStyle || bannerSrc) && (
        <div className={styles.imageContainer}>
          {bannerSrc && (
            <img
              src={bannerSrc}
              className={clsx(styles.bannerImage, {
                [styles.filledImage]: !defaultProductCardStyle,
              })}
              alt={productName || "product image"}
              width={defaultProductCardStyle ? 140 : undefined}
              height={defaultProductCardStyle ? 120 : undefined}
            />
          )}
          {!defaultProductCardStyle && !bannerSrc && (
            <img
              alt={productName || "product placeholder image"}
              className={styles.placeholderImage}
              src={ProductPlaceholderIcon}
            />
          )}
        </div>
      )}
    </div>
  );
}
